"use client";
import { motion } from "framer-motion";
import { GraduationCap, MapPin, PlayCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const features = [
  {
    icon: GraduationCap,
    title: "Pro-Level Curriculum",
    description:
      "Step-by-step lessons from surface prep to polished finishes, built for real jobsites.",
  },
  {
    icon: PlayCircle,
    title: "On-Demand Video Library",
    description:
      "Watch, pause, and rewatch techniques whenever you need a refresher — on desktop or mobile.",
  },
  {
    icon: MapPin,
    title: "Contractor Directory",
    description:
      "Homeowners can find skilled plaster contractors, and pros can get discovered by local leads.",
  },
];

export function FeaturesSection() {
  return (
    <section
      id="home-features"
      className="py-32 bg-background"
      data-header-scheme="light"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-serif text-4xl md:text-5xl font-light text-foreground mb-6 tracking-tight">
            Learn. Apply. Get Listed.
          </h2>
          <p className="font-sans text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Training for plaster applicators, and a directory for homeowners to
            hire trusted contractors.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <CardContent className="p-8 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-primary text-primary-foreground rounded-lg mb-6">
                    <feature.icon className="h-8 w-8" />
                  </div>
                  <h3 className="font-serif text-2xl font-medium text-foreground mb-4 tracking-tight">
                    {feature.title}
                  </h3>
                  <p className="font-sans text-muted-foreground leading-relaxed text-base">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
